if (window.innerWidth > 1199) {
  document.querySelectorAll('header li.menu-item.has-dropdown').forEach(item => {
    let closeTimeout;
    item.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      item.classList.add('is-open');
    });
    item.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        item.classList.remove('is-open');
      }, 250);
    });
    const link = item.querySelector('a');
    if (link) {
      link.addEventListener('click', e => {
        if (window.innerWidth <= 1199) {
          e.preventDefault();
          clearTimeout(closeTimeout);
          item.classList.toggle('is-open');
        }
      });
    }
  });
}

if (window.innerWidth < 1200) {
  const menuItems = document.querySelectorAll('header li.menu-item.has-dropdown');
  menuItems.forEach(item => {
    const link = item.querySelector('svg');
    if (!link) return;
    link.addEventListener('click', e => {
      e.preventDefault();
      menuItems.forEach(i => {
        if (i !== item) i.classList.remove('is-open');
      });
      item.classList.toggle('is-open');
    });
  });
  document.addEventListener('click', e => {
    menuItems.forEach(item => {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
      }
    });
  });
}

document.querySelector('.divider-scroll-down svg')?.addEventListener('click', () => {
  window.scrollBy({
    top: window.innerHeight * 0.9,
    left: 0,
    behavior: 'smooth'
  });
});


jQuery(document).ready(function($) {

    $('.cart-btn').on('click', function() {
        $('.slidecarthq-overlay, .slidecarthq').addClass('open');
    });
    $(document).on('click', '.slidecarthq-overlay, button[aria-label="close cart"]', function() {
        $('.slidecarthq-overlay, .slidecarthq').removeClass('open');
    });

    if ($(window).width() > 0) {
        var body = $("body").outerWidth();
        var contain = $("header.custom-header .wrapper").innerWidth();
        var less = body - contain;
        var total = less / 2;
        $(".banner-section").css('padding-left', total);
    }

	// $(".custom-accordion .accordion_head").click(function () {
  //     const $wrapper = $(this).closest(".accordion-wrapper");
  //     $(".accordion_body").slideUp(250);
  //     $(".plusminus").text("+");
  //     $(".accordion-wrapper").removeClass("active");
  //     if (!$(this).next(".accordion_body").is(":visible")) {
  //         $(this).next(".accordion_body").slideDown(250);
  //         $(this).children(".plusminus").text("–");
  //         $wrapper.addClass("active");
  //     }
  // });

  $(".custom-accordion .accordion_head").click(function () {
    const $wrapper = $(this).closest(".accordion-wrapper");
    const $body = $(this).next(".accordion_body");
    const $plusminus = $(this).children(".plusminus");

    if ($wrapper.hasClass("active")) {
        $wrapper.removeClass("active");
        $plusminus.text("+");
    } else {
        $(".accordion-wrapper.active").removeClass("active").find(".plusminus").text("+");
        $wrapper.addClass("active");
        $plusminus.text("–");
    }
});


	var owl = $(".owl-carousel.banner-products");
	  owl.owlCarousel({
		items: 1.75,
		margin: 40,
		loop: true,
		nav: true,
		responsive: {
		  0: {
			margin: 20,
            items: 1.5
		  },
          768: {
		    margin: 40,
            items: 1.85
		  }
		},
		autoplay: false,
        smartSpeed: 1000,
		dots: false,
		navText: ["<i class='circle-left'></i>", "<i class='circle-right'></i>"]
	});

    var owl1 = $(".owl-carousel.our-products-slider");
	  owl1.owlCarousel({
		items: 4,
		margin: 20,
		loop: true,
		center: true,
		nav: false,
		responsive: {
		  0: {
            items: 1.5
		  },
          768: {
            items: 2
		  },
          1200: {
            items: 3.25
		  },
          1440: {
            items: 4
		  }
		},
		autoplay: false,
        smartSpeed: 1000,
		dots: false,
		navText: ["<i class='circle-left'></i>", "<i class='circle-right'></i>"]
	});

    var owl2 = $(".owl-carousel.testimonial-slider");
	  owl2.owlCarousel({
		items: 3,
		margin: 20,
		loop: true,
		nav: false,
		center: true,
		responsive: {
		  0: {
            items: 1,
            autoplay: true
		  },
          768: {
            items: 2,
		    center: false,
        autoplay: false,
		  },
          1200: {
            items: 3,
		    center: true
		  }
		},
		autoplay: false,
    smartSpeed: 1000,
		dots: false,
		navText: ["<i class='circle-left'></i>", "<i class='circle-right'></i>"]
	});

  var maxHeight = 0;
  $("section.testimonials .item p.p-20").each(function () {
      var currentHeight = $(this).height();
      if (currentHeight > maxHeight) {
          maxHeight = currentHeight;
      }
  });
  $("section.testimonials .item p.p-20").height(maxHeight);

  var maxHeight1 = 0;
  $("section.testimonials .item h6:not(h6.authorname)").each(function () {
      var currentHeight1 = $(this).height();
      if (currentHeight1 > maxHeight1) {
          maxHeight1 = currentHeight1;
      }
  });
  $("section.testimonials .item h6:not(h6.authorname)").height(maxHeight1);

  var maxHeight2 = 0;
  $("section.our-products .our-products-slider .bottom p.p-20").each(function () {
      var currentHeight2 = $(this).height();
      if (currentHeight2 > maxHeight2) {
          maxHeight2 = currentHeight2;
      }
  });
  $("section.our-products .our-products-slider .bottom p.p-20").height(maxHeight2);
	
});



Userback = window.Userback || {};
Userback.access_token = '4465|17969|0pC59czd68HZ897LGv6kO5wwVnhWaGlmymPyChuoHi8bwBWuKB';
(function(id) {
var s = document.createElement('script');
s.async = 1;
s.src = 'https://static.userback.io/widget/v1.js';
var parent_node = document.head || document.body;
parent_node.appendChild(s);
})('userback-sdk');